<template>

  <div class="comments" >
    <!-- 绑定提现账户 -->
    <van-row >
      <van-col span="22" offset="1" class="my_add_bank">
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('column.Withdrawal_type')" @click="drawer = true" :value="list.account" is-link/>
          <van-action-sheet v-model="drawer">
            <van-picker
              safe-area-inset-bottom
              :title="$t('column.Withdrawal_type')"
              show-toolbar
              :columns = 'bank_list'
              @confirm = 'onConfirmbank'
              @cancel = 'onChangebanks'
              :confirm-button-text="$t('btn.submit')"
              :cancel-button-text="$t('btn.cancel')"
            />
          </van-action-sheet>
        </van-col>
        <van-col span="24">
          <van-cell-group>
            <van-field v-model="list.account_name" :label="$t('column.Account_name')" :placeholder="$t('placeholder.Please_enter_account_name')" />
          </van-cell-group>
        </van-col>
        <van-col span="24">
          <van-cell-group>
            <van-field v-model="list.branch_name" :label="$t('column.Branch_name')" :placeholder="$t('placeholder.Please_enter_branch_name')" />
          </van-cell-group>
        </van-col>
        <van-col span="24">
          <van-cell-group>
          <van-field v-model="list.account_number" :label="$t('column.Account_number')" :placeholder="$t('placeholder.Please_enter_account')" />
          </van-cell-group>
        </van-col>
        <van-col span="24" class="my_information_type">
          <van-cell :title="$t('column.Account_number_type')" @click="account_drawer = true" :value="list.account_type" is-link/>
          <van-action-sheet v-model="account_drawer">
            <van-picker
              safe-area-inset-bottom
              :title="$t('column.Account_number_type')"
              show-toolbar
              :columns = 'bank_type_list'
              @confirm = 'onConfirmbanktype'
              @cancel = 'onChangebanktypes'
              :confirm-button-text="$t('btn.submit')"
              :cancel-button-text="$t('btn.cancel')"
            />
          </van-action-sheet>
        </van-col>
        <van-col span="18" offset="3" class="my_add_bank_btn">
          <van-button type="primary" size="large" class="my_information_btn" @click="user_withdrawal_btn" safe-area-inset-bottom>{{ $t('btn.submit_to') }}</van-button>
        </van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  //请求接口组件
  import '@/assets/css/style.css'
  import axios from 'axios'
  import { Toast } from 'vant';
  export default {
    name: 'Index',
    data:function() {
      return {
        drawer:false,
        account_drawer:false,
        list:{},
        bank_list:[],
        bank_type_list:[
          {'text': this.$t('column.ordinary')},{'text': this.$t('column.Be_seated')},{'text': this.$t('column.savings')}
          ]
      }
    },
    created: function() {
      this.convert();
      this.get_bank();
      document.title = this.$t('title.add_bank')
    },
    methods: {
      onConfirmbank(item) {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        this.list.account = item.text
        this.drawer = false
      },
      onChangebanks () {
        this.drawer = false
      },
      onConfirmbanktype (item) {
        this.list.account_type = item.text
        this.account_drawer = false
      },
      onChangebanktypes () {
        this.account_drawer = false
      },
      convert: function() {
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        const id = this.$route.query.id;

        axios.get(this.baseUrlApi+"mapi/public/index.php/api/Userinfo_api/get_bank_edit",{ params:{ uid:uid,token:token, id:id }}).then(res =>{
          this.list = res.data.data
          if (res.data.data) {
            this.list=res.data.data;
          }
          console.log( this.list)
        })
      },
      user_withdrawal_btn() {
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        const id = this.$route.query.id;
        if (!this.list.account) {
          Toast(this.$t('Tips.Select_withdrawal_type'))
          return false
        }
        if (!this.list.account_name) {
          Toast(this.$t('Tips.Enter_account_name'))
          return false
        }
        if (!this.list.branch_name) {
          Toast(this.$t('Tips.Please_enter_branch_name'))
          return false
        }
        if (!this.list.account_number) {
          Toast(this.$t('Tips.Please_enter_account'))
          return false
        }

        if (!this.list.account_type) {
          Toast(this.$t('Tips.Please_enter_account_type'))
          return false
        }
        axios.get(this.baseUrlApi+"mapi/public/index.php/api/Userinfo_api/vue_add_bank",{
          params:{
            id:id,
            uid:uid,
            token:token,
            account: this.list.account,
            account_number:this.list.account_number,
            account_name: this.list.account_name,
            branch_name: this.list.branch_name,
            account_type: this.list.account_type
          }
        }).then(res =>{
          console.log(res.data.data)
          if (res.data.code === 0) {
            Toast.fail({ message: res.data.msg, duration: 1000 })
          } else {
            Toast.success({ message: res.data.msg, duration: 1000 })
            this.user_account = false
            this.$router.push({path:'/withdrawal',query:{uid:uid, token: token }});
            this.convert()
          }
        })
      },
      get_bank(){

        const uid = this.$route.query.uid;
        const token = this.$route.query.token;

        axios.get(this.baseUrlApi+"mapi/public/index.php/api/User_api/get_bank",{ params:{ uid:uid,token:token }}).then(res =>{
          if(res.data.code==1){
            const list = res.data.data
          //  this.bank_list = [{'text':'支付宝'},{'text': '微信'}]
            for(let i=0;i<list.length;i++){
              const name ={'text':list[i]['name'] }
              this.bank_list.push(name);
            }
          }
        })
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/add_bank.vue